/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    11/06/2018
 */
import { Sector } from '@lemsar/common/domains/models/sector';
import { Vocational } from '@lemsar/common/domains/models/vocational';
import { User } from '@lemsar/auth/domains/models/user';
import { Bank } from '@lemsar/institution/domains/model/bank';

export class Institution {
    public id: string;
    public code: string;
    public name: string;
    public owner: string;
    public since: number;
    public address: string;
    public phone: string;
    public fax: string;
    public email: string;
    public website: string;
    public locationLong: string;
    public locationLat: string;
    public condition: string;
    public accreditation: string;
    public expiredAt: Date;
    public area: number;
    public status: string;
    public createdAt: string;
    public institutionableType: string;
    public postalCode: PostalCode;
    public bigCover: string;
    public medCover: string;
    public smCover: string;
    public bigLogo: string;
    public medLogo: string;
    public smLogo: string;
    public institutionable: any;
    public institutionType: InstitutionType;
    public capacity: string;
    public step: number;
    public checked: boolean;
    public preWorkCard: boolean;
    public preWorkCardNotes: string;
    public preWorkCardStatus: string;
    public preWorkCardSubmissionStatus: string;
    public user: User;

    public bankAccountNumber: string;
    public bankAccountName: string;
    public bankBranchName: string;

    public about: string;
    public jkpNotes: string;
    public jkpStatus: string;
    public prevJkpStatus: string;
    public jkpBankAccountName: string;
    public jkpBankAccountNumber: string;
    public jkpBankId: string;
    public jkpDraftPkbFile: string;
    public jkpPicMobile: string;
    public jkpPicName: string;
    public jkpPkbDate: string;
    public jkpPkbNumber: string;
    public jkpBank: Bank;
    public jkpPkbSignatureFile: string;
    public jkpBankBranchName: string;
    public jkpPkbInstitutionNumber: string;
    public entityName: string;
    public jkpDraftPkbSignatureFile: string;
}

export class InstitutionType {
    public id: string;
    public name: string;
}

export class PostalCode {
    public id: string;
    public code: string;
    public village: Village;
}

export class Village {
    public id: string;
    public name: string;
    public subDistrict: SubDistrict;
}

export class SubDistrict {
    public id: string;
    public name: string;
    public city: City;
}

export class City {
    public id: string;
    public name: string;
    public province: Province;
}

export class Province {
    public id: string;
    public name: string;
}

export class InstitutionPictures {
    public Id: string;
    public institutionId: string;
    public bigImage: string;
    public smImage: string;
    public medImage: string;
}

export class UploadInstitutionPicture {
    public image: File;
}

export class UploadInstitutionLogo {
    public logo: File;
}

export class Employee {
    public id: string;
    public identityNumber: number;
    public name: string;
    public education: string;
    public status: string;
    public gender: string;
    public birthday: Date;
    public address: string;
    public disability: boolean;
    public stillWork: boolean;
    public dukcapil?: boolean;
}

export class PotentialSector {
    public id: string;
    public sector: Sector;
}

export class PopularVocational {
    public id: string;
    public vocational: Vocational;
}

export class VocationalTraining {
    public id: string;
    public vocational: Vocational;
}

export class EmployeeSummary {
    public male: number;
    public female: number;
}

export class EligibleInstitution {
    public completed: boolean;
    public verified: boolean;
    public accredited: boolean;
    public haveInstructors: boolean;
    public eligibleApplyToJkp: boolean;
    public existsProgram: boolean;
    public eligibleProposeToJkp: { profile: boolean; bankAccount: boolean; document: boolean };
}



// WEBPACK FOOTER //
// ./src/lemsar/institution/domains/model/institution.ts